import { FC } from 'react';

const ThinkingDots: FC = () => (
  <div className="navi-thinking-dots" aria-label="Navi is thinking">
    <span />
    <span />
    <span />
  </div>
);

export default ThinkingDots;
